import request from '@/utils/request'

export const gasApi = {
  overview: () => request.get('/gas/overview'),
  weather: {
    current: params => request.get('/gas/weather/current', { params })
  },
  orgOptions: () => request.get('/gas/org/options'),
  mapPoints: () => request.get('/gas/map/points'),
  mapDashboard: () => request.get('/gas/map/dashboard'),
  mapGeocode: params => request.get('/gas/map/geocode', { params, skipErrorHandler: true }),

  org: {
    list: params => request.get('/gas/org/list', { params }),
    save: data => request.post('/gas/org', data),
    remove: id => request.delete(`/gas/org/${id}`),
    quotaPanel: id => request.get(`/gas/org/${id}/quota-panel`),
    quotaPanelSave: data => request.post('/gas/org/quota/panel', data),
    batchStatus: data => request.put('/gas/org/batch-status', data),
    batchRemove: data => request.delete('/gas/org/batch', { data })
  },
  quota: {
    list: params => request.get('/gas/org/quota/list', { params }),
    save: data => request.post('/gas/org/quota', data),
    remove: id => request.delete(`/gas/org/quota/${id}`),
    batchRemove: data => request.delete('/gas/org/quota/batch', { data })
  },
  device: {
    stats: () => request.get('/gas/device/stats'),
    modelOptions: () => request.get('/gas/device/model-options'),
    terminalTypeOptions: () => request.get('/gas/device/terminal-type-options', { skipErrorHandler: true }),
    detailPanel: id => request.get(`/gas/device/${id}/detail-panel`),
    subDevices: id => request.get(`/gas/device/${id}/sub-devices`),
    list: params => request.get('/gas/device/list', { params }),
    save: data => request.post('/gas/device', data),
    saveSubDeviceName: data => request.put(`/gas/device/${data.deviceId}/sub-device-name`, data),
    remove: id => request.delete(`/gas/device/${id}`),
    batchStatus: data => request.put('/gas/device/batch-status', data),
    batchRemove: data => request.delete('/gas/device/batch', { data }),
    recycleList: params => request.get('/gas/device/recycle/list', { params }),
    restore: id => request.post(`/gas/device/recycle/${id}/restore`),
    batchRestore: data => request.post('/gas/device/recycle/batch-restore', data),
    purge: id => request.delete(`/gas/device/recycle/${id}`),
    batchPurge: data => request.delete('/gas/device/recycle/batch', { data }),
    pushConfigs: id => request.get(`/gas/device/${id}/push-configs`),
    savePushConfig: data => request.post('/gas/device/push-config', data),
    removePushConfig: id => request.delete(`/gas/device/push-config/${id}`),
    pushNow: id => request.post(`/gas/device/push-config/${id}/push-now`)
  },
  deviceType: {
    list: params => request.get('/gas/device-type/list', { params }),
    save: data => request.post('/gas/device-type', data),
    remove: id => request.delete(`/gas/device-type/${id}`),
    batchRemove: data => request.delete('/gas/device-type/batch', { data }),
    options: () => request.get('/gas/device-type/options', { skipErrorHandler: true })
  },
  site: {
    list: params => request.get('/gas/site/list', { params }),
    save: data => request.post('/gas/site', data),
    remove: id => request.delete(`/gas/site/${id}`),
    batchRemove: data => request.delete('/gas/site/batch', { data }),
    options: () => request.get('/gas/site/options', { skipErrorHandler: true })
  },
  projectCategory: {
    list: params => request.get('/gas/project-category/list', { params }),
    save: data => request.post('/gas/project-category', data),
    remove: id => request.delete(`/gas/project-category/${id}`),
    batchRemove: data => request.delete('/gas/project-category/batch', { data }),
    options: () => request.get('/gas/project-category/options', { skipErrorHandler: true })
  },
  terminal: {
    list: params => request.get('/gas/terminal/list', { params }),
    monitor: params => request.get('/gas/terminal/monitor/list', { params }),
    monitorUsage: () => request.get('/gas/terminal/monitor/usage-summary'),
    monitorTrend: params => request.get('/gas/terminal/monitor/trend', { params }),
    stats: () => request.get('/gas/terminal/stats/summary'),
    statsDashboard: params => request.get('/gas/terminal/stats/dashboard', { params }),
    save: data => request.post('/gas/terminal', data),
    remove: id => request.delete(`/gas/terminal/${id}`),
    batchRemove: data => request.delete('/gas/terminal/batch', { data })
  },
  message: {
    stats: () => request.get('/gas/terminal/message/stats'),
    list: params => request.get('/gas/terminal/message/list', { params }),
    receiveConfigList: params => request.get('/gas/terminal/message/receive-config/list', { params }),
    saveReceiveConfig: data => request.put('/gas/terminal/message/receive-config', data),
    save: data => request.post('/gas/terminal/message', data),
    remove: id => request.delete(`/gas/terminal/message/${id}`),
    batchRemove: data => request.delete('/gas/terminal/message/batch', { data })
  },
  iotCard: {
    stats: () => request.get('/gas/iot-card/stats'),
    projectOptions: () => request.get('/gas/iot-card/project-options'),
    list: params => request.get('/gas/iot-card/list', { params }),
    save: data => request.post('/gas/iot-card', data),
    remove: id => request.delete(`/gas/iot-card/${id}`),
    batchRemove: ids => request.delete('/gas/iot-card/batch', { data: { ids } })
  },
  protocol: {
    list: params => request.get('/gas/protocol/list', { params }),
    detail: id => request.get(`/gas/protocol/${id}`),
    save: data => request.post('/gas/protocol', data),
    remove: id => request.delete(`/gas/protocol/${id}`),
    batchRemove: data => request.delete('/gas/protocol/batch', { data }),
    parseTest: (protocolId, data) => request.post(`/gas/protocol/${protocolId}/parse-test`, data),
    runtimeStatus: () => request.get('/gas/protocol/runtime/status'),
    runtimeReload: () => request.post('/gas/protocol/runtime/reload'),
    collectDevice: id => request.post(`/gas/protocol/runtime/device/${id}/collect`),
    paramList: params => request.get('/gas/protocol/param/list', { params }),
    paramSave: data => request.post('/gas/protocol/param', data),
    paramRemove: id => request.delete(`/gas/protocol/param/${id}`),
    paramBatchRemove: data => request.delete('/gas/protocol/param/batch', { data })
  },
  alarm: {
    list: params => request.get('/gas/alarm/list', { params }),
    export: params => request.get('/gas/alarm/export', { params }),
    realtimeStats: () => request.get('/gas/alarm/realtime/stats'),
    siteOptions: () => request.get('/gas/alarm/site-options'),
    save: data => request.post('/gas/alarm', data),
    resolve: (id, params) => request.put(`/gas/alarm/${id}/resolve`, null, { params }),
    process: (id, params) => request.put(`/gas/alarm/${id}/process`, null, { params }),
    shield: (id, params) => request.put(`/gas/alarm/${id}/shield`, null, { params }),
    remove: id => request.delete(`/gas/alarm/${id}`),
    batchRemove: data => request.delete('/gas/alarm/batch', { data })
  },
  alarmRule: {
    stats: () => request.get('/gas/alarm/rule/stats'),
    list: params => request.get('/gas/alarm/rule/list', { params }),
    save: data => request.post('/gas/alarm/rule', data),
    remove: id => request.delete(`/gas/alarm/rule/${id}`),
    batchRemove: data => request.delete('/gas/alarm/rule/batch', { data }),
    setEnabled: (id, enabled) => request.put(`/gas/alarm/rule/${id}/enabled`, {}, { params: { enabled } }),
    batchEnabled: data => request.put('/gas/alarm/rule/batch-enabled', data),
    copy: id => request.post(`/gas/alarm/rule/${id}/copy`)
  },
  reportDaily: {
    list: params => request.get('/gas/report/daily/list', { params }),
    save: data => request.post('/gas/report/daily', data),
    remove: id => request.delete(`/gas/report/daily/${id}`),
    batchRemove: data => request.delete('/gas/report/daily/batch', { data })
  },
  reportFlowDaily: {
    stats: params => request.get('/gas/report/flow-daily/stats', { params }),
    list: params => request.get('/gas/report/flow-daily/list', { params }),
    detail: id => request.get(`/gas/report/flow-daily/${id}`),
    hourly: (id, params) => request.get(`/gas/report/flow-daily/${id}/hourly`, { params }),
    export: params => request.get('/gas/report/flow-daily/export', { params }),
    exportHourly: params => request.get('/gas/report/flow-daily/export-hourly', { params })
  },
  reportFlowMonthly: {
    stats: params => request.get('/gas/report/flow-monthly/stats', { params }),
    list: params => request.get('/gas/report/flow-monthly/list', { params }),
    detail: params => request.get('/gas/report/flow-monthly/detail', { params }),
    export: params => request.get('/gas/report/flow-monthly/export', { params })
  },
  reportFlowYearly: {
    stats: params => request.get('/gas/report/flow-yearly/stats', { params }),
    list: params => request.get('/gas/report/flow-yearly/list', { params }),
    detail: params => request.get('/gas/report/flow-yearly/detail', { params })
  },
  reportFlowCustom: {
    stats: params => request.get('/gas/report/flow-custom/stats', { params }),
    list: params => request.get('/gas/report/flow-custom/list', { params }),
    detail: params => request.get('/gas/report/flow-custom/detail', { params })
  },
  reportFlowUsage: {
    stats: params => request.get('/gas/report/flow-usage/stats', { params }),
    list: params => request.get('/gas/report/flow-usage/list', { params }),
    export: params => request.get('/gas/report/flow-usage/export', { params })
  },
  sysConfig: {
    get: () => request.get('/gas/system/config'),
    save: data => request.put('/gas/system/config', data),
    uploadCompanyLogo: file => {
      const fd = new FormData()
      fd.append('file', file)
      return request.post('/gas/system/company-logo', fd, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
    },
    clearCompanyLogo: () => request.delete('/gas/system/company-logo')
  },
  operLog: {
    list: params => request.get('/gas/system/log/list', { params }),
    remove: id => request.delete(`/gas/system/log/${id}`),
    batchRemove: data => request.delete('/gas/system/log/batch', { data }),
    clearAll: () => request.delete('/gas/system/log/clear')
  },
  backup: {
    list: params => request.get('/gas/system/backup/list', { params }),
    create: () => request.post('/gas/system/backup'),
    remove: id => request.delete(`/gas/system/backup/${id}`),
    batchRemove: data => request.delete('/gas/system/backup/batch', { data })
  }
}
